import crumbs from '@/common/utils/breadcrumbs/crumbs';
import store from '@/common/store';


const resolvePath = (object, path, defaultValue) => path
  .split('.')
  .reduce((o, p) => (o ? o[p] : defaultValue), object);


export const setBreadcrumbs = (crumbName, args) => {
  const func = resolvePath(crumbs, crumbName, null);
  if (!func) {
    throw new Error(`Crumb function ${crumbName} not found`);
  }
  store.commit('setBreadcrumbs', func(...(args || [])));
};

export const resetBreadcrumbs = () => {
  store.commit('setBreadcrumbs', null);
};
